<template>
  <ais-instant-search
    :search-client="searchClient"
    :index-name="courseIndex"
    class="mobile-course-carousel"
  >
    <div class="mobile-course-carousel__link">
      <div
        @click="searchTopic(tag)"
        class="mobile-course-carousel__link-wrapper"
      >
        <h3 class="mobile-course-carousel__link">{{ tag }}</h3>
      </div>
    </div>
    <ais-hits>
      <swiper
        slot-scope="{ items }"
        class="swiper-container mobile-course-carousel__swiper-container"
        :options="swiperOption"
      >
        <swiper-slide
          v-for="course in items"
          :key="course.id"
          class="swiper-slide mobile-course-carousel__tile"
          :style="
            `background-image: url(${$getCourseBackground(
              course,
              'small'
            )}), linear-gradient(${$getGradient()})`
          "
        >
          <router-link
            :to="{
              name: 'course',
              params: { id: course.id, slug: course.slug },
            }"
            class="mobile-course-carousel__course-link"
          >
            <div class="mobile-course-carousel__overlay"></div>
            <div class="mobile-course-carousel__details">
              <div class="mobile-course-carousel__title">
                {{ course.title }}
              </div>
              <div class="mobile-course-carousel__instructor">
                <p class="mobile-course-carousel__lead">Instructor</p>
                <p class="mobile-course-carousel__name">
                  {{
                    `${course.presenter.first_name} ${course.presenter.last_name}`
                  }}
                </p>
              </div>
              <div class="mobile-course-carousel__branding">
                {{ course.vendor }}
              </div>
            </div>
          </router-link>
        </swiper-slide>
        <div
          class="swiper-button-prev"
          style="background: none;"
          slot="button-prev"
        >
          <i class="material-icons mobile-left-advance-carousel"
            >keyboard_arrow_left</i
          >
        </div>
        <div
          class="swiper-button-next"
          style="background: none; right: 20px;"
          slot="button-next"
        >
          <i class="material-icons mobile-right-advance-carousel"
            >keyboard_arrow_right</i
          >
        </div>
      </swiper>
    </ais-hits>
    <ais-configure
      :query="''"
      :filters="`tags.label:${JSON.stringify(tag)}`"
      hitsPerPage="20"
    />
  </ais-instant-search>
</template>

<script>
import algoliasearch from 'algoliasearch/lite'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
  name: 'MobileCourseCarousel',
  data() {
    return {
      searchClient: algoliasearch(
        process.env.VUE_APP_ALGOLIA_APP_ID,
        process.env.VUE_APP_ALGOLIA_APP_KEY
      ),
      courseIndex: process.env.VUE_APP_ALGOLIA_COURSES_INDEX,
      swiperOption: {
        slidesPerView: 'auto',
        spaceBetween: 10,
        freeMode: true,
        loop: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          disabledClass: 'swiper-button-disabled',
        },
      },
    }
  },
  props: {
    tag: {
      type: String,
      required: true,
    },
  },
  components: {
    swiper,
    swiperSlide,
  },
  methods: {
    searchTopic(query) {
      this.$store.dispatch('search/setSearchQuery', query)
      this.$router.push({ name: 'search' })
    },
  },
}
</script>

<style lang="scss" scoped>
.mobile-course-carousel {
  $this: &;
  padding-right: 0;
  padding-bottom: 50px;
  &__link-wrapper {
    margin-left: 15px;
  }
  &__link {
    color: var(--white);
    font-size: 1.3rem;
    transition: all 0.5s ease;
    text-decoration: none;
    cursor: pointer;
    margin-bottom: 0;
    &:hover {
      color: var(--orange);
    }
  }
  &__swiper-container {
    padding: 10px;
    background-color: var(--light-gray);
  }
  &__tile {
    text-align: left;
    padding: 10px;
    height: 250px;
    color: var(--white);
    position: relative;
    background-color: var(--orange);
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    &:hover {
      cursor: pointer;
      #{$this}__overlay {
        opacity: 1;
      }
    }
  }
  &__overlay {
    position: absolute;
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    right: 0;
    top: 0;
    z-index: 0;
    opacity: 0;
    transition: 0.5s all ease;
  }
  &__course-link {
    color: var(--white);
    text-decoration: none;
    height: 100%;
    z-index: 1;
    &:hover {
      color: var(--white);
      text-decoration: none;
    }
  }
  &__details {
    width: 100%;
    padding: 30px;
  }
  &__title {
    font-size: 1.4rem;
    font-weight: 700;
    width: 230px;
    position: absolute;
  }
  &__instructor {
    position: absolute;
    bottom: 10%;
    left: 8%;
  }
  &__lead {
    color: var(--gray);
    text-transform: uppercase;
    margin: 0;
    font-size: 0.8rem;
    font-weight: 500;
  }
  &__name {
    color: var(--white);
    font-weight: 700;
    margin: 0;
  }
  &__branding {
    font-weight: 700;
    font-size: 0.8rem;
    position: absolute;
    right: 10%;
    bottom: 10%;
    text-transform: uppercase;
  }
  .swiper-button-disabled {
    display: none;
  }
}
</style>
